export default "__VITE_ASSET__CPGtyQx3__"